<script setup lang="ts">
import {reactive} from "vue";
import {useRoute, useRouter} from "vue-router";
import {resetPassword} from "@/Services/auth";
import {Button, InputText, Label, Password} from "@/Components/Library";
import {Messages} from "@/Components/Forms";
import {useMainStore} from "@/Stores/store";

const $store = useMainStore();
const currentRoute = useRoute();
const router = useRouter();
const bag = "reset-password";

const state = reactive({
    loading: false,
});

const form = reactive({
    token: currentRoute.params.token,
    email: currentRoute.query.email as string,
    password: "",
    password_confirmation: "",
});

const submit = async () => {
    try {
        state.loading = true;
        const data = await resetPassword(form);
        form.password = "";
        form.password_confirmation = "";
        $store.addMessage({
            text: "Your password has been reset successfully. You can now log in.",
            type: "success",
            bag: bag,
        });
        setTimeout(() => {
            router.push("/login");
        }, 3000);
    } catch (error) {
        console.log(error);
    } finally {
        state.loading = false;
    }
};
</script>
<template>
    <div>
        <h1 class="mb-4 border-b-2 border-white pb-1 text-xl font-bold">New Password</h1>
        <form @submit.prevent="submit" class="flex flex-col gap-4">
            <div class="flex flex-col">
                <Label for="email" class="mb-1" required>Email</Label>
                <InputText
                    class="bg-transparent text-white"
                    id="email"
                    type="email"
                    v-model="form.email"
                    required
                    autofocus
                    fluid
                    autocomplete="username"
                />
            </div>
            <div class="flex flex-col">
                <Label for="password" class="mb-1" required>Password</Label>
                <Password
                    inputId="password"
                    v-model="form.password"
                    required
                    fluid
                    autocomplete="new-password"
                    toggleMask
                    :feedback="false"
                    inputClass="bg-transparent text-white"
                />
            </div>
            <div class="flex flex-col">
                <Label for="password_confirmation" class="mb-1" required>Confirm Password</Label>
                <Password
                    inputId="password_confirmation"
                    v-model="form.password_confirmation"
                    required
                    autocomplete="new-password"
                    fluid
                    toggleMask
                    :feedback="false"
                    inputClass="bg-transparent text-white"
                />
            </div>
            <Messages :bag="bag" />
            <div class="mb-16 flex flex-col items-center gap-3">
                <Button
                    :loading="state.loading"
                    type="submit"
                    class="bg-askr-green text-white hover:brightness-110"
                    :icon="{icon: 'mdi:lock'}"
                >
                    Reset Password
                </Button>
                <RouterLink to="/login">Log in</RouterLink>
            </div>
        </form>
    </div>
</template>
